/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file The RepeatSplitFormComponent is used split in repeat in 2.
 * The form is activated with an action button and displayed in the overlay.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };
